<template>
  <i v-if="data === null"><code>null</code></i>
  <i v-else-if="data === undefined"><code>undefined</code></i>
  <div
    v-else
    class="json-viewer-wrapper"
    :class="{ 'json-viewer-wrapper--dark': darkmodeEnabled }"
  >
    <button
      type="button"
      class="json-viewer-copy"
      @click="copyPayload"
    >
      {{ copied ? "copied!" : "copy" }}
    </button>
    <VueJsonPretty
      :data="data"
      :deep="closed ? 0 : 1"
      :show-length="closed"
      :show-line="true"
      :show-icon="true"
      :theme="darkmodeEnabled ? 'dark' : 'light'"
      @node-click="aKeyClick"
    />
  </div>
</template>

<script setup lang="ts">
import { defineComponent, ref } from "vue";

import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import { addDarkmodeListener } from "@/helper/darkmodeListener";

defineComponent({
  name: "json-viewer",
});
const props = withDefaults(
  defineProps<{
    /** Incoming json data | 传入的json数据 */
    data: unknown,
    /** Whether to collapse | 是否折叠 */
    closed?: boolean,
    /** Preview mode | 预览模式 */
    previewMode?: boolean,
    /** key click callback | key 点击回调 */
    keyClick?: (...args: any[]) => any,
  }>(),
  {
    closed: false,
    previewMode: true,
    keyClick: () => {},
  }
);

const darkmodeEnabled = addDarkmodeListener();
const copied = ref(false);
let copiedTimeout: number | null = null;

function aKeyClick(...data: any[]) {
  console.log(...data);
  return props.keyClick(...data);
}

async function copyPayload() {
  await copyText(JSON.stringify(props.data, null, 2));
  copied.value = true;
  if (copiedTimeout !== null) {
    window.clearTimeout(copiedTimeout);
  }
  copiedTimeout = window.setTimeout(() => {
    copied.value = false;
    copiedTimeout = null;
  }, 2000);
}

async function copyText(text: string) {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      console.warn("Clipboard API copy failed, falling back.", error);
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "-9999px";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  try {
    const copiedSuccessfully = document.execCommand("copy");
    if (!copiedSuccessfully) {
      throw new Error("document.execCommand('copy') returned false.");
    }
  } finally {
    textarea.remove();
  }
}
</script>

<style lang="scss">
// only works if not scoped. TODO: why?
// bright theme
.json-view-container {
  &.bright {
    background-color: #f2f2f2;
    .json-view {
      font-family: Menlo, Consolas, "Courier New", Courier, FreeMono, monospace !important;

      .json-note {
        font-size: 12px;
        font-style: italic;
      }
    }
  }
}
</style>
